import { t } from '@lingui/core/macro';
import { StudentPlacementStatus } from '@duke-hq/svc-api-db';

// The dashboard tile and the side panel both render the same five groups in the
// same order, with the same colours. Define them once here so the two stay in sync.
//
// "On hold" is a flag rather than a status, so its group has no statuses and is
// sourced from the separate on-hold count.

export type WorkPlacementGroupKey =
  | 'onHold'
  | 'sourcing'
  | 'active'
  | 'awaitingEvidence'
  | 'complete';

export type WorkPlacementGroup = {
  key: WorkPlacementGroupKey;
  label: string;
  backgroundColour: string;
  statuses: StudentPlacementStatus[];
};

export function getWorkPlacementGroups(): WorkPlacementGroup[] {
  return [
    { key: 'onHold', label: t`On hold`, backgroundColour: 'blue.400', statuses: [] },
    {
      key: 'sourcing',
      label: t`Sourcing`,
      backgroundColour: 'cyan.500',
      statuses: [
        StudentPlacementStatus.AWAITING_CHECKLIST,
        StudentPlacementStatus.AWAITING_APPROVAL,
        StudentPlacementStatus.AWAITING_PLACEMENT,
        StudentPlacementStatus.APPLYING,
        StudentPlacementStatus.INTERVIEWING,
      ],
    },
    {
      key: 'active',
      label: t`Active`,
      backgroundColour: 'cyan.600',
      statuses: [StudentPlacementStatus.IN_PROGRESS],
    },
    {
      key: 'awaitingEvidence',
      label: t`Awaiting Evidence`,
      backgroundColour: 'teal.500',
      statuses: [StudentPlacementStatus.AWAITING_EVIDENCE],
    },
    {
      key: 'complete',
      label: t`Complete`,
      backgroundColour: 'green.600',
      statuses: [StudentPlacementStatus.COMPLETED],
    },
  ];
}
